
import XhUser from './XhUser';
import arrayMixin from './arrayMixin';

export default {
  name: 'XhUserCell', // 新建 user-cell
  components: {
    XhUser: XhUser
  },
  mixins: [arrayMixin],
  inheritAttrs: false,
  props: {
    // 是否单选
    radio: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '选择员工'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    max: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      showPopover: false // 展示popover
    };
  },

  computed: {
    showDataValue: function showDataValue() {
      if (this.dataValue && this.dataValue.length > this.max) {
        return this.dataValue.slice(0, this.max);
      }
      return this.dataValue;
    }
  },
  watch: {},
  mounted: function mounted() {},
  updated: function updated() {
    if (this.$refs.reference) {
      this.$parent.popperElm = this.$refs.reference.$el;
    }
  },

  methods: {
    /**
     * 选中
     */
    checkUsers: function checkUsers(data) {
      if (this.radio && data && data.length) {
        this.showPopover = false;
      }

      this.dataValue = data;
      this.$emit('value-change', {
        item: this.item,
        index: this.index,
        value: data
      });
    },


    /**
     * 删除
     */
    deleteuser: function deleteuser(index) {
      this.dataValue.splice(index, 1);
      this.$emit('value-change', {
        item: this.item,
        index: this.index,
        value: this.dataValue
      });
    },


    /**
     * 聚焦动作
     */
    focusClick: function focusClick() {
      this.$emit('focus');
    },
    handleClose: function handleClose() {
      if (this.$parent.popperElm) {
        this.showPopover = false;
      }
    }
  }
};